import { WMS } from '@/constants/featureFlags';
import { buildReceivePalletWrites } from '@/utilities/manifestPallets';
import { canMarkReceived } from '@/components/InventoryUnit/utils';

const NO_WRITES = { items: [], received_pallet_ids: [] };

/**
 * Is this ReceiveModal submission an actual warehouse receipt?
 *
 * The modal is shared with the middle-mile ship / pickup / arrival steps, which are not receipts.
 * Those pass their own timestamp attr (mm_est_ship_date, mm_ship_date, arrived_date), so keying on
 * received_date pins us to a real receive without depending on the status the modal derived — it
 * infers RECEIVED from whether received_date is set, which is a rule this module does not own.
 */
export const isReceiveSubmission = (events, params) =>
    params?.timestampAttr === 'received_date' &&
    (events || []).some(
        (event) => event.action === params?.action && event.status === 'RECEIVED' && !!event.received_date
    );

/**
 * Pallet variables for UPSERT_EVENT. Empty unless the client runs the WMS and this is a receive:
 * the WMS reads received off the pallet, so an events-only receive never shows on the manifest.
 * Stock units that left the shelf get no pallet.
 */
export const receivePalletVariables = ({ events, params, order, circles }) => {
    if (!circles?.[WMS] || !isReceiveSubmission(events, params)) return NO_WRITES;

    const { items, pallet_ids } = buildReceivePalletWrites(order, { canReceive: canMarkReceived });
    return { items, received_pallet_ids: pallet_ids };
};
